import { EMPTY_OBJ, EMPTY_ARR } from '@constants';

import useResourceList from './useResourceList';
import useQuery from './useQuery';
import mutationFactory from './mutationFactory';

import api from '..';

export const useRegionsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'regions', api: api.regions }, queryVariables, queryConfig);

  return {
    regions: queryResult.resolvedData,
    latestRegions: queryResult.latestData,
    ...queryResult,
  };
};

export const useRegion = ({ id }, queryConfig = {}) => {
  const queryResult = useQuery(['region', { id }], api.regions.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    region: queryResult.data || EMPTY_OBJ,
    ...queryResult,
  };
};

export const useRegionsByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['regions', { ids }], api.regions.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    regions: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};

const mutation = mutationFactory({ invalidate: 'regions' });

export const useDeleteRegion = mutation(api.regions.remove);
export const useCreateRegion = mutation(api.regions.create);
export const useSaveRegion = mutation(api.regions.save);
export const useUpdateRegion = mutation(api.regions.update);
